import React, { useEffect, useRef } from 'react';
import {
	BrowserMultiFormatReader,
	DecodeHintType,
	BarcodeFormat
} from '@zxing/library';


interface IMobileInlineScannerV2Props {
	onScanned: (result: string) => void;
}

export const MobileInlineScannerV2 = (props: IMobileInlineScannerV2Props) => {
	const videoRef = useRef<HTMLVideoElement|null>(null);
	const codeReaderRef = useRef<BrowserMultiFormatReader | null>(null);

	const lastScanRef = useRef<{ data: string; timestamp: number }>({
		data: '',
		timestamp: 0
	});

	const { onScanned } = props;

	useEffect(() => {
		if (!videoRef.current) return;

		// Nur DataMatrix (+ optional weitere Formate) decodieren
		const hints = new Map();
		hints.set(DecodeHintType.POSSIBLE_FORMATS, [
			BarcodeFormat.DATA_MATRIX,
			BarcodeFormat.QR_CODE,
			BarcodeFormat.CODE_128
		]);

		// const codeReader = new BrowserMultiFormatReader(hints, 500);

		// Reader nur einmal pro Mount erzeugen
		const codeReader = codeReaderRef.current ?? new BrowserMultiFormatReader(hints, /* timeBetweenScansMillis */ 500);
		codeReaderRef.current = codeReader;

		let unmounted = false;

		codeReader
			.decodeFromVideoDevice(
				null,
				videoRef.current,
				(result, error) => {
					if (unmounted) return;

					if (result) {
						console.log('Gefundener Code:', result.getText());
						// codeReader.reset();

						const now = Date.now();
						const { data, timestamp } = lastScanRef.current;

						// 2 Sekunden Cooldown
						// if (code.data === data && now - timestamp < 2000) {
						if (now - timestamp < 2000) {
							return; // Doppler -> ignoriere
						}

						// Neuen Code merken
						lastScanRef.current = {
							data: result.getText(),
							timestamp: now
						};

						onScanned(result.getText());
					}
					if (error) {
						// keine Erfolge ignorieren
					}
				}
			)
			.catch(console.error);

		// return () => { 
		// 	codeReader.reset(); 
		// };

		const vid = videoRef.current;

		return () => {
			unmounted = true;

			// 1) ZXing stoppen (beendet intern getUserMedia / Tracks – je nach Browser)
			try {
				codeReaderRef.current?.reset();
			} catch (e) {
				console.warn('reset failed', e);
			}

			// 2) MediaStream *hart* beenden, falls noch aktiv
			// const vid = videoRef.current;
			const stream = (vid?.srcObject as MediaStream | null) ?? null;
			if (stream) {
				for (const track of stream.getTracks()) {
				try { track.stop(); } catch {}
				}
			}

			// 3) Quelle lösen und neu laden (wichtig für Safari/iOS)
			if (vid) {
				vid.srcObject = null;
				try { vid.load(); } catch {}
			}

			// 4) Reader-Ref freigeben
			codeReaderRef.current = null;
		};

	}, [onScanned]);

	return (
		<div style={{
			position: 'relative',
			width: 300,
			// height: 300, 
			aspectRatio: 16 / 9
		}}>
			<video
				ref={videoRef}
				style={{ width: '100%', height: '100%', objectFit: 'cover' }}
				muted

				autoPlay
				playsInline
			/>
		</div>
	);
};

